import styled from 'styled-components';

export const ActionGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 4px 0;

  @media screen and (min-width: 768px) {
    flex-direction: row;

    & > * {
      margin-left: 8px;
    }

  }
`;

export const TableActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  margin-bottom: 16px;

  ${ActionGroup}:not(:first-child) {
    border-left: 2px solid ${({theme}) => theme.colors.bg_gray_dark};
    margin-left: 8px;
  }
`;